import { render, staticRenderFns } from "./PrintCompetitorsTable.vue?vue&type=template&id=1c850a9c&"
import script from "./PrintCompetitorsTable.vue?vue&type=script&lang=js&"
export * from "./PrintCompetitorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports